// import React, { Fragment, useState, useRef } from "react";
// import _ from "lodash";

// import doctorFormFields from "./doctorFormFields";
// import RegisterFields from "./RegisterFields";

// export const DoctorForm = (props) => {
//   const inputRef = useRef({});

//   const renderFields = () => {
//     return _.map(
//       doctorFormFields,
//       ({ label, name, type, options, required }) => {
//         return (
//           <RegisterFields
//             name={name}
//             label={label}
//             type={type}
//             value={inputRef.current.name}
//             options={options}
//             required={required}
//             onChange={props.onChange(name)}
//             node={props.node}
//             onSelect={props.onSelect}
//           />
//         );
//       }
//     );
//   };

//   return <Fragment>{renderFields()}</Fragment>;
// };

import React, { Fragment, useRef } from "react";
import _ from "lodash";
import doctorFormFields from "./doctorFormFields";
import RegisterFields from "./RegisterFields";

export const DoctorForm = (props) => {
  const inputRef = useRef({});

  const isAdminEmail = props.paymentAccess;

  const filteredFields = doctorFormFields.filter(function (f) {
    var isRate =
      f.name === "diagnosisCashRate" ||
      f.name === "diagnosisSocialSecurityRate" ||
      f.name === "postConsultCashRate" ||
      f.name === "postConsultSocialSecurityRate" ||
      f.name === "cpapFollowupCashRate" ||
      f.name === "cpapFollowupSocialSecurityRate";
    if (isRate && !isAdminEmail) return false; // hide rate fields for non-admins
    return true;
  });

  const renderFields = () => {
    return _.map(
      filteredFields,
      function ({ label, name, type, options, required }) {
        return (
          <RegisterFields
            key={name}
            name={name}
            label={label}
            type={type}
            // Use per-field value if you really need to control it; otherwise omit 'value'
            value={inputRef.current[name]}
            options={options}
            required={required}
            onChange={props.onChange(name)}
            node={props.node}
            onSelect={props.onSelect}
          />
        );
      }
    );
  };

  return <Fragment>{renderFields()}</Fragment>;
};
